// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

import { createIllustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@atlassian/jira-illustration/src/ui/types.tsx';
import srcDark from '../../assets/ticket-bulb-chat.png'; // eslint-disable-line import/no-duplicates, jira/import/no-duplicates
import srcLight from '../../assets/ticket-bulb-chat.png'; // eslint-disable-line import/no-duplicates

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
	autoDark: false,
});

export default Illustration;

// for advanced use only
const viewBox: SVGViewBox = [0, 0, 960, 540];
export { viewBox };
